import { useSearchParams } from 'react-router-dom';
import CampaignsTab from '../components/whatsapp/CampaignsTab';
import InboxTab from '../components/whatsapp/InboxTab';
import NewCampaignWizard from '../components/whatsapp/NewCampaignWizard';
import StatusBanner from '../components/whatsapp/StatusBanner';
import TemplatesTab from '../components/whatsapp/TemplatesTab';
import TriggersTab from '../components/whatsapp/TriggersTab';

/** Tab key (also the ?tab= value) -> label and its component. */
const TABS = [
  { key: 'campaigns', label: 'Campaigns', Component: CampaignsTab },
  { key: 'new', label: 'New campaign', Component: NewCampaignWizard },
  { key: 'templates', label: 'Templates', Component: TemplatesTab },
  { key: 'inbox', label: 'Inbox', Component: InboxTab },
  { key: 'triggers', label: 'Triggers', Component: TriggersTab },
];

/** WhatsApp outreach: campaigns, templates, inbox and triggers. The open tab lives in the URL. */
const WhatsAppPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const active = TABS.find((t) => t.key === searchParams.get('tab')) ?? TABS[0];
  const { Component } = active;
  // After a send the wizard hands over here: Campaigns tab, that campaign already open.
  const openCampaign = (campaignId) => setSearchParams({ tab: 'campaigns', campaign: campaignId });
  // The Inbox composer sends here when the 24-hour window is closed and only a template can go out.
  const openNewCampaign = () => setSearchParams({ tab: 'new' });

  return (
    <div
      className={
        active.key === 'inbox' ? 'flex h-full min-h-[560px] max-w-full flex-col gap-4' : 'space-y-4 max-w-full'
      }
    >
      {active.key !== 'inbox' && <h1 className="text-2xl font-serif text-foreground">WhatsApp</h1>}
      <StatusBanner />

      <div role="tablist" aria-label="WhatsApp sections" className="flex gap-1 overflow-x-auto border-b border-border">
        {TABS.map((tab) => {
          const selected = tab.key === active.key;
          return (
            <button
              key={tab.key}
              type="button"
              role="tab"
              aria-selected={selected}
              onClick={() => setSearchParams({ tab: tab.key })}
              className={`px-4 py-2 text-sm whitespace-nowrap border-b-2 -mb-px transition-colors ${
                selected
                  ? 'border-foreground text-foreground font-medium'
                  : 'border-transparent text-muted-foreground hover:text-foreground'
              }`}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      <div role="tabpanel" className={active.key === 'inbox' ? 'min-h-0 flex-1' : undefined}>
        <Component
          onSent={openCampaign}
          initialCampaignId={searchParams.get('campaign') || undefined}
          onOpenNewCampaign={openNewCampaign}
          initialPhone={searchParams.get('phone') || undefined}
          linkKey={searchParams.get('t') || undefined}
        />
      </div>
    </div>
  );
};

export default WhatsAppPage;
